import React, { useEffect, useState } from "react";
import SnAvailabilityListTableComponent from "./snAvailabilityListTable.component";
import { useSelector } from "react-redux";
import {
  checkSerialNumberAvailability,
} from "modules/serial-number/redux";
import { selectLoading } from "modules/notification";

function SnAvailabilityListTableContainer({
  handleReload,
  format,
  activeType,
  formik,
  isPreview = false,
}) {
  const snAvailabilityList = useSelector(
    (state) => state.serialNumber.snAvailabilityList.data
  );
  const isError = useSelector(
    (state) => state.serialNumber.snAvailabilityList.isError
  );
  const isLoading = useSelector((state) =>
    selectLoading(state, checkSerialNumberAvailability.typePrefix)
  );

  const lang = useSelector((state) => state.constant.languages);

  const [list, setList] = useState([]);

  useEffect(() => {
    if (snAvailabilityList.length && !isPreview) {
      let totalQty = snAvailabilityList.reduce((total, sn) => {
        if (sn.is_available) {
          total += sn.quantity;
        }
        return total;
      }, 0);
      formik.setFieldValue("quantity", totalQty);
    }

    if (isPreview) {
      setList(snAvailabilityList.filter((sn) => !!sn.is_available));
    } else {
      setList(snAvailabilityList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [snAvailabilityList]);

  return (
    <SnAvailabilityListTableComponent
      isLoading={isLoading}
      error={isError}
      list={list}
      handleReload={handleReload}
      lang={lang}
      format={format}
      activeType={activeType}
      isPreview={isPreview}
    />
  );
}

export default SnAvailabilityListTableContainer;
